export default __webpack_public_path__ + "static/media/Git2.a47c9923.png";